import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ChargepointType } from './chargepoints-api.service';

const HOST = environment.serverUrl;
const EVENTS_API_URL = HOST + '/events';

export enum EventType {
  UNREACHABLE = 'UNREACHABLE'
}

export enum EventSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL'
}

export enum EventStatus {
  CREATED = 'CREATED',
  RESOLVED = 'RESOLVED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
}

export interface Event {
  id: string;
  type: EventType;
  status: EventStatus;
  severity: EventSeverity;
  chargepointType: ChargepointType;
  chargepointId: string;
  createdAt?: Date;
  stillIdentifiedAt?: Date;
  resolvedAt?: Date;
}

function reviveEvent(event: Event): Event {
  event.createdAt = event.createdAt ? new Date(event.createdAt) : undefined;
  event.stillIdentifiedAt = event.stillIdentifiedAt ? new Date(event.stillIdentifiedAt) : undefined;
  event.resolvedAt = event.resolvedAt ? new Date(event.resolvedAt) : undefined;
  return event;
}

export interface EventSearchCriteria {
  severity?: EventSeverity | null;
  status?: EventStatus | null;
  chargepointId?: string | null;
  includeResolved?: boolean;
}

@Injectable({ providedIn: 'root' })
export class EventsApiService {

  constructor(private http: HttpClient) { }

  public searchEvents(searchCriteria: EventSearchCriteria): Observable<Event[]> {
    return this.http.post<Event[]>(`${EVENTS_API_URL}/search`, {...searchCriteria}, { responseType: 'json' })
      .pipe(
        map(chargepoints => chargepoints.map(reviveEvent))
      );
  }
}
